import styled from '@emotion/styled'
import React from 'react'
// import LockerMenu from '../../Components/LockerMenu'
import { PageWrapper } from '../../Styles/style'
import Footer from '../S8_Footer'
import Header from '../S1_Header'
import Products from '../S2_chart'
import Protocol from '../S3_why'
import Works from '../S4_Tokenomics'
import Facts from '../S5_facts'
import Howtobuy from '../S6_Howtobuy'
import Faqs from '../S7_faqs'
import bkImg from '../../../assets/SB-bg.png'
const HeaderWrapper = styled.div`
    background-image: url(${bkImg});
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    /* position: fixed; */
    
`
const MainPage = (props) => {
  return (
    
    <HeaderWrapper>
    <PageWrapper>
        <Header />
        <Products />
        <Protocol />
        <Works />
        <Facts />
        <Howtobuy />
        {/* <Faqs /> */}
        <Footer />
    </PageWrapper>
    </HeaderWrapper>
  )
}

export default MainPage